import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  slug: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  rating: number;
  coverImage: string;
  chapters: number;
  status: string;
  updateTime: string;
  views: number;
  tags: string[];
}

export default function ComicCard({
  slug,
  title,
  author,
  category,
  categorySlug,
  rating,
  coverImage,
  chapters,
  status,
  views,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 1000000) return `${(v / 1000000).toFixed(1)}M`;
    if (v >= 1000) return `${(v / 1000).toFixed(1)}K`;
    return String(v);
  };

  return (
    <Link
      to={`/article/${slug}`}
      className="group block"
    >
      <article className="relative overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all duration-300 hover:border-primary-200">
        <div className="relative w-full aspect-[3/4] overflow-hidden">
          <img
            src={coverImage}
            alt={`${title} - 韩国漫画`}
            title={`${title} 韩漫在线阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute top-2 left-2">
            <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
              status === '连载中'
                ? 'bg-primary-500 text-background-50'
                : 'bg-secondary-500 text-background-50'
            }`}>
              {status}
            </span>
          </div>
          <div className="absolute top-2 right-2 flex items-center gap-1 bg-foreground-900/70 backdrop-blur-sm rounded-full px-2 py-0.5">
            <i className="ri-star-fill text-accent-400 text-xs"></i>
            <span className="text-xs text-background-50 font-medium">{rating}</span>
          </div>
        </div>

        <div className="p-3">
          <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
            {title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{author}</p>
          <div className="flex items-center justify-between mt-2">
            <Link
              to={`/category/${categorySlug}`}
              className="text-xs text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full hover:bg-primary-100 transition-colors duration-200 whitespace-nowrap"
              onClick={(e) => e.stopPropagation()}
            >
              {category}
            </Link>
            <span className="text-xs text-foreground-400 whitespace-nowrap">
              {chapters}话 · {formatViews(views)}
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
}